import React, { Component } from 'react'
import Already from './Already'
import Wait from './Wait'
import Record from './Record'
import { Tabs } from 'hljd'
import store from '../store'
import { observer } from 'mobx-react'
import style from '../style.module.less'
const TabPane = Tabs.TabPane

@observer
export default class extends Component {
  render() {
    const { activeTab } = store
    return (
      <div className={style.tabs}>
        <Tabs activeKey={activeTab} onChange={store.changeTab}>
          <TabPane tab="已上线" key="1">
            <Already />
          </TabPane>
          <TabPane tab="待上线" key="2">
            <Wait />
          </TabPane>
          <TabPane tab="申请记录" key="3">
            <Record />
          </TabPane>
        </Tabs>
      </div>
    )
  }
}
